import { useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import { useTitle } from 'react-use';

import { SettingsPage } from '@/components/templates/SettingsPage/SettingsPage';
import { useAccount } from '@/hooks/useAccount';
import useSegments from '@/segment/useSegments';
import { PageName } from '@/shared/types/segment';

import { DataProcessingFieldset } from './fieldsets/DataProcessingFieldset';

export const DataPrivacy = () => {
  const { t } = useTranslation();
  const { slug, accountRole } = useAccount();

  useTitle(t('pages.data_privacy_simple'));

  const canUpdate = accountRole === 'owner';

  useSegments(PageName.DATA_PROCESS);

  return (
    <SettingsPage>
      <DataProcessingFieldset key={slug} readOnly={!canUpdate} />
    </SettingsPage>
  );
};
